<template>
  <div :class="$style.list">
    <div v-for="(el, index) in data" :key="index" :class="$style.item">
      <div :class="$style.pic">
        <img v-lazy="lazyImg(el.pic_url)" :alt="el.title" />
      </div>
      <div :class="$style.tag">
        <p>{{ el.title }}</p>
        <p>{{ el.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default() {
        return []
      },
    },
  },
  methods: {
    lazyImg(src) {
      return {
        src,
        loading: require('./images/loading.jpg'),
      }
    },
  },
}
</script>

<style lang="less" module>
@list-width: 13.6rem;
@item-width: 4.41rem;
@item-height: 3.23rem;
@item-pic-width: 4rem;
@item-pic-height: 2.92rem;
@item-margin-bottom: 0.15rem;
@r: 1.29; // 放大倍数

.list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: @list-width;
  margin: 0 auto;
}

.item {
  .size(@item-width, @item-height);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: @item-margin-bottom;

  .pic {
    .size(@item-pic-width, @item-pic-height);
    transition: all 0.3s;

    img {
      .size(100%);
    }
  }

  .tag {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: none;
    flex-direction: column;
    justify-content: center;
    height: 1rem;
    border-bottom: 0.03rem solid @primary;
    background: #fff url('./images/activity-icon.png') no-repeat 3.83rem 0.5rem;
    background-size: 0.25rem 0.25rem;
    cursor: default;

    p {
      width: 3.8rem;
      text-indent: 0.34rem;
      color: #000;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;

      &:nth-child(2) {
        margin-top: 1em;
        font-size: 12px;
        text-transform: uppercase;
        color: @text-color;
      }
    }
  }

  &:hover {
    .pic {
      .size(100%);
      box-shadow: 0 0 0.2rem fade(#444446, 20%);
    }

    .tag {
      display: flex;

      :global {
        animation: fadeIn 0.3s 0.1s both;
      }
    }
  }
}

@media screen and (max-width: @tablet-width) {
  .list {
    width: @list-width * @r;
  }

  .item {
    .size(@item-width * @r, @item-height * @r);
    margin-bottom: @item-margin-bottom * @r;

    .pic {
      .size(@item-pic-width * @r, @item-pic-height * @r);
    }
  }
}

@media screen and (max-width: @mini-width) {
  .item {
    @width: @item-width * @r;
    @height: @item-height * @r;

    .size(@width + @width / 2, @height + @height / 2);
    margin-bottom: @item-margin-bottom * @r * 2;

    &:last-child {
      display: none;
    }

    .pic {
      .size(100%);
    }

    &:hover {
      .tag {
        display: none;
        animation: none;
      }
    }
  }
}
</style>
